import './SFCEdit.less';
// @ts-ignore
import ImageResize from 'quill-image-resize';
import React, { useState, useEffect, useMemo } from 'react';
import Quill, { Sources } from 'quill';
import Delta from 'quill-delta';
import MarkdownShortcuts from './markdown';
import ImagePaste from './imagePaste';
import ImgAlign from './imgAlign';
import ImgSize from './imgSize';
import ImgResize from './imgResize';
import ImgBlot from './imgBlot';
import hrBlot from './hrBlot';
import SFCToolbar from './SFCToolbar';
import SFCLinkManage from './SFCLinkManage';
import SFCCatelog from './SFCCatelog';
import { buildRandomStr } from './utils';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const xss = require('xss');

// 修改图片尺寸以及对其
Quill.register('modules/imageResize', ImageResize);
// 支持markdown
Quill.register('modules/markdownShortcuts', MarkdownShortcuts);
// 图片
Quill.register(ImgBlot);
// 分割线
Quill.register(hrBlot);
// 图片复制
Quill.register('modules/imageDropAndPaste', ImagePaste);

type Props = ISFCEditProps;

export interface IHeadItem {
  type: string;
  txt: string;
}

export interface IImgInsert {
  img: {
    src: string;
  };
}

export interface ISFCEditProps {
  readOnly?: boolean;
  value?: string;
  onChange?: (val: string) => void;
  placeholder?: string;
  onRef?: (quill: Quill) => void;
  showCatelog?: boolean;
  className?: string;
}

export function SFCEdit(props: Props) {
  const [quill, setQuill] = useState<Quill | undefined>(undefined);
  const [cacheVal, setCacheVal] = useState('');
  const {
    placeholder,
    readOnly,
    onChange,
    onRef,
    showCatelog,
    value: sourceValue,
    className = ''
  } = props;
  const [editConId] = useState(`k-quill-edit${buildRandomStr()}`);
  const editDom = document.getElementById(editConId);

  const value = useMemo(() => {
    return xss(sourceValue) || '';
  }, [sourceValue]);

  useEffect(() => {
    if (value && quill) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
  }, [quill, value]);

  useEffect(() => {
    if (quill) {
      quill.root.contentEditable = readOnly ? 'false' : 'true';
    }
  }, [quill, readOnly]);

  useEffect(() => {
    const myQuill = new Quill(`#${editConId}`, {
      placeholder: placeholder || '',
      scrollingContainer: 'html',
      debug: false,
      modules: {
        markdownShortcuts: {},
        imageDropAndPaste: {},
        syntax: true,
        toolbar: {
          container: '#toolbar-con'
          // formula: 'customFormulaHandler'
        },
        // 修改图片尺寸以及对其
        imageResize: {
          modules: [ImgResize, ImgSize, ImgAlign],
          overlayStyles: {
            border: '1px dashed rgba(51,170,255,0.6)'
          }
        }
      }
    });

    const editorChange = (eventName: string, delta: Delta, oldContents: Delta, source: Sources) => {
      if (eventName === 'text-change' && onChange && source === 'user') {
        const root = myQuill.root;

        Array.from(root.querySelectorAll('img')).forEach(item => {
          const src = item.src;
          const {
            env: { NODE_ENV, REACT_APP_PROXY_TARGET }
          } = process;
          const urlPre =
            NODE_ENV === 'development' ? REACT_APP_PROXY_TARGET || '' : location.origin;

          // if (src.indexOf('data:image') !== 0 && src.indexOf(urlPre) !== 0) {
          //   APIS.FileApi.fileByUrlUsingPost(src).then(res => {
          //     if (res.code == 0 && res.result) {
          //       item.src = res.result.previewUrl || '';
          //     } else {
          //       item.src = BanImg;
          //     }
          //   });
          // }
        });

        setCacheVal(root.innerHTML);
        onChange(root.innerHTML);
      }
    };

    myQuill.on('editor-change', editorChange);

    // 将初始化好的编辑器对象注册到组件中
    setQuill(myQuill);

    onRef && onRef(myQuill);

    return () => {
      myQuill.off('editor-change', editorChange);
    };
  }, [editConId, onChange, onRef, placeholder]);

  const scrollToTargetPart = (index: number) => {
    if (editDom) {
      const target = editDom.querySelectorAll('h1,h2,h3')[index];

      target.scrollIntoView({
        block: 'center'
      });
    }
  };

  return (
    <div className={`k-base-edit ${readOnly ? 'k-base-edit-readonly' : ''} ${className}`}>
      {showCatelog && <SFCCatelog itemClick={scrollToTargetPart} val={cacheVal || value} />}
      <SFCToolbar quill={quill} />
      <SFCLinkManage rootId={editConId} readOnly={readOnly} />

      <div id={editConId} />
    </div>
  );
}

export default SFCEdit;
